import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { addOnlineForm, showFormChoiceModal } from 'actions/form';
import { displayMode } from 'common/forms/displayMode';

import Button from 'components/Common/Buttons';

function isNullOrWhitespace(input) {
  return !input || input.trim() === '';
}

class FormSelectionCard extends React.Component {
  onAddForm() {
    const { dispatch, formType, formDisplayMode } = this.props;
    const maxMobileWidth = 992;
    const legalEntity = {
      id: 1
    };
    if (formDisplayMode === displayMode.Stacked || window.innerWidth <= maxMobileWidth) {
      dispatch(showFormChoiceModal(formType));
    } else {
      dispatch(addOnlineForm(formType, legalEntity));
    }
  }

  render() {
    const { title, introductionMessageId, isEnabled, isAddingForm, formType } = this.props;
    return (
      <div className="card">
        <h2>{ title }</h2>
        <p>{ !isNullOrWhitespace(introductionMessageId) && <FormattedMessage id={ introductionMessageId } /> }</p>
        <Button id={ `${ title.toLowerCase() }-start-button` } value="Start Form" className={ `btn-primary${ isAddingForm === formType ? ' btn-active' : '' }` } onClick={ () => isEnabled && this.onAddForm() } />
      </div>
    );
  }
}

FormSelectionCard.propTypes = {
  dispatch: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  formType: PropTypes.string.isRequired,
  introductionMessageId: PropTypes.string.isRequired,
  isEnabled: PropTypes.bool,
  isAddingForm: PropTypes.string,
  formDisplayMode: PropTypes.number.isRequired
};

FormSelectionCard.defaultProps = {
  isEnabled: false,
  isAddingForm: null
};

function mapStateToProps(state) {
  const {
    form: {
      isAddingForm
    },
    app: {
      onlineConfig
    }
  } = state;

  return {
    isAddingForm,
    formDisplayMode: onlineConfig ? onlineConfig.formDisplayMode : displayMode.Irs
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FormSelectionCard);
